import { c as _c } from "react/compiler-runtime";
import { Server, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
const pill = "inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-semibold";

/** Teal pill promising the file stays on the device. */
export function PrivacyBadge(t0) {
  const $ = _c(6);
  const {
    children: t1,
    className
  } = t0;
  const children = t1 === undefined ? "Processed on your device" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn(pill, "bg-image-tint text-image-strong", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ShieldCheck className="size-4 shrink-0" aria-hidden="true" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t2) {
    t4 = <span className={t2}>{t3}{children}</span>;
    $[3] = children;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}

/** Indigo pill on server tools (Phase 5): the file is sent to our converter. */
export function ServerBadge(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(pill, "bg-brand-tint text-brand-strong", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Server className="size-4 shrink-0" aria-hidden="true" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <span className={t1}>{t2}Uses our server</span>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}